import { useTranslation } from '@/i18n';
import { formatZeroAmount } from '@/utils/formatAmount';
import { Caption } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames/bind';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);

export interface ListAmountProps {
  totalValue?: string;
  consumptionTax?: string;
  withholdingTax?: string;
  foreignCurrency?: string;
  totalTransactionDetailsValue?: string;
  paymentTotalMismatchCaption?: string;
}

export const ListAmount = ({
  totalValue,
  consumptionTax,
  withholdingTax,
  foreignCurrency,
  totalTransactionDetailsValue,
  paymentTotalMismatchCaption,
}: ListAmountProps) => {
  const { t } = useTranslation();

  const hasConsumptionTax = !!consumptionTax;
  const hasWithholdingTax = !!withholdingTax;
  const hasForeignCurrency = !!foreignCurrency;

  return (
    <div className={cx('list-amount')}>
      <div className={cx('main-table')}>
        {/* Payment Total */}
        <div className={cx('row', 'payment-total')}>
          <div className={cx('label', 'text-bold')}>
            {t('approving_invoice_report_detail_payment_total')}
          </div>
          <div className={cx('value-container')}>
            <span className={cx('text-value', 'text-bold')}>
              {formatZeroAmount(totalValue)}
            </span>
            {hasForeignCurrency && (
              <span className={cx('text-value', 'foreign-currency')}>
                {formatZeroAmount(foreignCurrency)}
              </span>
            )}
          </div>
        </div>
        {paymentTotalMismatchCaption && (
          <div className={cx('paymentTotalMismatchCaption')}>
            <Caption type='alert'>{paymentTotalMismatchCaption}</Caption>
          </div>
        )}

        {/* Border */}
        <div className={cx('border')} />

        {/* Detail Total */}
        <div className={cx('row')}>
          <div className={cx('label')}>
            {t('approving_invoice_report_detail_detail_total')}
          </div>
          <div className={cx('value-container')}>
            <span className={cx('text-value')}>
              {formatZeroAmount(totalTransactionDetailsValue)}
            </span>
            {hasForeignCurrency && (
              <span className={cx('text-value', 'foreign-currency', 'hidden')}>
                {formatZeroAmount(foreignCurrency)}
              </span>
            )}
          </div>
        </div>

        {/* Consumption Tax */}
        {hasConsumptionTax && (
          <div className={cx('row', 'consumption-tax')}>
            <div className={cx('label', 'consumption-tax')}>
              {t('approving_invoice_report_detail_consumption_tax')}
            </div>
            <div className={cx('value-container', 'consumption-tax')}>
              <span className={cx('text-value')}>
                {formatZeroAmount(consumptionTax)}
              </span>
              {hasForeignCurrency && (
                <span
                  className={cx('text-value', 'foreign-currency', 'hidden')}
                >
                  {formatZeroAmount(foreignCurrency)}
                </span>
              )}
            </div>
          </div>
        )}

        {/* Withholding Tax */}
        {hasWithholdingTax && (
          <div className={cx('row')}>
            <div className={cx('label')}>
              {t('approving_invoice_report_detail_withholding_tax')}
            </div>
            <div className={cx('value-container')}>
              <span className={cx('text-value')}>
                {formatZeroAmount(withholdingTax)}
              </span>
              {hasForeignCurrency && (
                <span
                  className={cx('text-value', 'foreign-currency', 'hidden')}
                >
                  {formatZeroAmount(foreignCurrency)}
                </span>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
